import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

const TestimonialCard = ({ quote, name, delay }) => (
  <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay={delay}>
    <Box className="testimonial-card">
      <Typography variant="body1" className="testimonial-quote">
        "{quote}"
      </Typography>
      <Typography variant="h6" className="testimonial-name">
        {name}
      </Typography>
    </Box>
  </Grid>
);

const Testimonials = () => {
  return (
    <Box id="testimonials" className="testimonials">
      <Container>
        <Typography variant="h4" className="section-title" data-aos="fade-up">
          What Our Clients Say
        </Typography>
        <Grid className='testimonial-container' container spacing={4} sx={{ marginTop: '30px' }}>
          <TestimonialCard quote="SSN M3 Technologies helped us streamline our processes. Excellent service!" name="Kori Brandl, Director - Business Transformation" delay="200" />
          <TestimonialCard quote="A fantastic partner to work with, their expertise is top-notch!" name="Gonzalo Jurado, Enterprise Applications Manager" delay="300" />
        </Grid>
      </Container>
    </Box>
  );
};

export default Testimonials;
